import React from "react";
import { useTheme } from "@material-ui/core/styles";
import CircularProgress from "@material-ui/core/CircularProgress";
import useActionBtnStyles from "../../styles/actionBtnStyles";

/**
 * Botão base do sistema. Usa o token actionBtn do design system
 * (cor de destaque do whitelabel, radius 12, sombra leve).
 *
 * `tone="primary"` (default) → background primary do whitelabel
 * `tone="ghost"`            → transparente com borda discreta (ex.: cancelar)
 * `tone="danger"`           → vermelho (excluir)
 */
const BaseActionButton = ({
    onClick,
    children,
    disabled,
    loading,
    type,
    iconSvg,
    style,
    tone = "primary",
}) => {
    const theme = useTheme();
    const btn = useActionBtnStyles();
    const isDark = theme.mode === "dark" || theme.palette?.type === "dark";

    const baseStyle = {
        minWidth: 120,
        height: 38,
        justifyContent: "center",
        ...style,
    };

    let toneStyle = {};
    if (tone === "ghost") {
        toneStyle = {
            background: "transparent",
            color: isDark ? "#e9edef" : "#111b21",
            border: `1px solid ${isDark ? "rgba(255,255,255,0.16)" : "rgba(0,0,0,0.16)"}`,
            boxShadow: "none",
        };
    } else if (tone === "danger") {
        toneStyle = {
            background: "#e53935",
            color: "#fff",
        };
    }

    const className = tone === "ghost" ? btn.ghostBtn : btn.actionBtn;

    return (
        <button
            disabled={disabled || loading}
            onClick={onClick}
            type={type || "button"}
            className={className}
            style={{ ...baseStyle, ...toneStyle }}
        >
            {loading ? (
                <CircularProgress size={14} style={{ color: tone === "ghost" ? (isDark ? "#e9edef" : "#111b21") : "#fff" }} />
            ) : iconSvg}
            <span>{children}</span>
        </button>
    );
};

export const SaveButton = ({ onClick, children, disabled, loading, type, style }) => (
    <BaseActionButton
        onClick={onClick}
        disabled={disabled}
        loading={loading}
        type={type || "submit"}
        tone="primary"
        style={style}
        iconSvg={
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M5 14L8.5 17.5L19 6.5" />
            </svg>
        }
    >
        {children || "Salvar"}
    </BaseActionButton>
);

export const CancelButton = ({ onClick, children, disabled, style }) => (
    <BaseActionButton
        onClick={onClick}
        disabled={disabled}
        type="button"
        tone="ghost"
        style={style}
        iconSvg={
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M18 6L6 18M6 6l12 12" />
            </svg>
        }
    >
        {children || "Cancelar"}
    </BaseActionButton>
);

export default BaseActionButton;
